import datepicker from '../../../../../../modules/Gull/Framework/datepicker.js';
import validation from '../../../../../../modules/Gull/Framework/validation.js';

const form = {

	/**
	 * Initializes form functions
	 *
	 * @returns {void}
	 */
	init: function() {
		form.initEvents();
		form.initPopover();
		form.conditionalQuestions.init();
	},

	/**
	 * Initializes event listeners for various form-related events such as change, blur, keyup, and form submission.
	 *
	 * @returns {void}
	 */
	initEvents: function() {

		document.addEventListener('change', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('.btn-group-toggle input')) {
					form.applyToDOM(event);
					form.conditionalQuestions.toggle();
					form.conditionalQuestions.toggleUploads(event);
					break;
				}
			}
		}, false);

		document.addEventListener('change', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('[data-alert] [type=radio]')) {
					form.alert(event);
					break;
				}
			}
		}, false);

		document.addEventListener('blur', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum')) {
					form.opbouwschema.get();
					break;
				}
			}
		}, false);

		document.addEventListener('keyup', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum')) {
					form.opbouwschema.get();
					break;
				}
			}
		}, false);

		document.addEventListener('blur', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren')) {
					form.opbouwschema.get();
					break;
				}
			}
		}, false);

		document.addEventListener('keyup', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren')) {
					form.opbouwschema.get();
					break;
				}
			}
		}, false);

		document.addEventListener('click', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('#opbouwSchemaToevoegen')) {
					form.opbouwschema.add();
					break;
				}
			}
		}, false);

		document.addEventListener('click', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('.opbouw-schema-item-verwijder')) {
					form.opbouwschema.delete(event);
					break;
				}
			}
		}, false);

		$('form[data-validate]').submit(function() {
			$('.form-actie select').each(function() {
				if ($(this).hasClass('is-invalid')) {
					$(this).closest('[data-actie-werkgever-vraag]').find('.btn').addClass('btn-outline-danger');
				} else {
					$(this).closest('[data-actie-werkgever-vraag]').find('.btn').removeClass('btn-outline-danger');
				}
			});
		});

	},

	/**
	 * Initializes Bootstrap popovers for elements with the 'data-bs-toggle="popover"' attribute.
	 *
	 * @returns {void}
	 */
	initPopover: function() {
		const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
		[...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl));
	},

	/**
	 * Displays a warning modal based on the specified conditions and values from the form.
	 *
	 * @param {Event} event - The event triggering the alert functionality.
	 * @returns {void}
	 */
	alert: function(event) {

		const datasetJSON = event.target.closest('[data-actie-werkgever-vraag]').dataset.alert;
		const dataset = JSON.parse(datasetJSON);
		const condition = dataset[0];
		const heading = dataset[1];
		const message = dataset[2];
		const submitButton = event.target.closest('form').querySelector('[type=submit]');
		const value = event.target.closest('.btn-group-toggle').querySelector('[type=radio]:checked').value;
		const modalElement = document.getElementById('modalWaarschuwing');
		const modalElementHeading = modalElement.querySelector('.modal-header .modal-title');
		const modalElementBody = modalElement.querySelector('.modal-body p');

		if (condition == value) {
			submitButton.setAttribute('disabled', 'true');
			modalElementHeading.innerHTML = heading;
			modalElementBody.innerHTML = message;
			const alertModal = new bootstrap.Modal(modalElement);
			alertModal.show();
		} else {
			submitButton.removeAttribute('disabled');
		}

	},

	/**
	 * Applies changes to the DOM based on the provided event.
	 *
	 * @param {Event} event - The event triggering the DOM changes.
	 *
	 * @returns {void}
	 */
	applyToDOM: function(event) {

		const value = event.target.value || '';
		const select = event.target.closest('div').querySelector('select');
		const container = event.target.closest('.btn-group-toggle').querySelector('.btn');

		select.value = value;
		select.dispatchEvent(new Event('change'));
		select.classList.remove('is-invalid');
		container.classList.remove('btn-outline-danger');

	},

	conditionalQuestions: {

		/**
		 * Initializes the conditionalQuestions by hiding specified containers and removing validation requirements from selects and inputs.
		 *
		 * @returns {void}
		 */
		init: function() {

			const containers = document.querySelectorAll('[data-conditions]');
			const selects = document.querySelectorAll('[data-conditions] select');
			const inputs = document.querySelectorAll('[data-conditions] input');

			containers.forEach(el => el.classList.add('d-none'));
			containers.forEach(el => el.classList.remove('d-md-table-row'));
			selects.forEach(el => validation.removeRequired(el));
			inputs.forEach(el => validation.removeRequired(el));

		},

		/**
		 * Toggles the visibility of file input fields, removes name attributes for hidden inputs,
		 * and updates a corresponding hidden input field to indicate the presence of visible file inputs.
		 *
		 * @returns {void}
		 */
		toggleUploads: function() {

			var uploadElements = [];

			document.querySelectorAll('.form-actie [data-actie-werkgever-vraag].d-none input[type=file]').forEach(function(element) {
				const originalName = element.getAttribute('name');
				element.setAttribute('data-original-name', originalName);
				element.removeAttribute('name');
			});

			document.querySelectorAll('.form-actie  [data-actie-werkgever-vraag]:not(.d-none) input[type=file]').forEach(function(element) {
				const originalName = element.getAttribute('data-original-name');
				element.setAttribute('name', originalName);
				uploadElements.push(element);
			});

			var elemenNoFileUploadInput = document.querySelector('[name=noFileUpload]');
			if (elemenNoFileUploadInput !== null) {
				if (uploadElements.length > 0) {
					elemenNoFileUploadInput.value = 0;
				} else {
					elemenNoFileUploadInput.value = 1;
				}
			}
		},

		/**
		 * Toggles the visibility of elements based on conditional questions and adjusts validation requirements accordingly.
		 *
		 * @returns {void}
		 */
		toggle: function() {

			document.querySelectorAll('[data-conditions]').forEach(function(element) {

				const visibilityConditions = form.conditionalQuestions.check(element);

				if (visibilityConditions) {
					element.classList.remove('d-none');
					element.classList.add('d-md-table-row');
					element.querySelectorAll('select,input:not([type=hidden]:not([type=radio])').forEach(el => validation.addRequired(el));
				} else {
					element.classList.add('d-none');
					element.classList.remove('d-md-table-row');
					element.querySelectorAll('select,input').forEach(el => validation.removeRequired(el));
					element.querySelectorAll('input[type=radio]').forEach(radioButton => radioButton.checked = false);
					element.querySelectorAll('[data-actie-werkgever-antwoord]').forEach(antwoord => antwoord.value = '');
				}

			});

		},

		/**
		 * Checks the visibility conditions of an element based on preceeding questions' values.
		 *
		 * @param {HTMLElement} el - The element to check conditions for.
		 *
		 * @returns {boolean} - True if conditions are met, otherwise false.
		 */
		check: function(el) {

			let conditionsMet = true;
			let currentQuestionConditions = JSON.parse(el.dataset.conditions);
			Object.keys(currentQuestionConditions).forEach(id => {
				let targetValue = document.getElementById(id).value?.toLowerCase();
				let conditionValues = currentQuestionConditions[id];
				if (typeof conditionValues == 'string') {
					conditionValues = [conditionValues];
				}
				let conditionValuesLowercase = conditionValues.map(item => item.toLowerCase());
				if (!conditionValuesLowercase.includes(targetValue)) {
					conditionsMet = false;
				}
			});

			return conditionsMet;
		},
	},

	opbouwschema: {

		/**
		 * Retrieves data from the 'opbouwSchemaContainer' and updates the 'opbouwSchema' input field.
		 * Uses a setTimeout to delay the retrieval, likely for asynchronous purposes.
		 *
		 * @returns {void}
		 */
		get: function() {
			setTimeout(function() {
				var opbouwSchema = {};
				var elements = document.querySelectorAll('#opbouwSchemaContainer .opbouw-schema-item');
				for (var i = 0; i < elements.length; i++) {
					var childElements = elements[i].getElementsByClassName('opbouw-schema-item-input');
					var period = {};
					for (var a = 0; a < childElements.length; a++) {
						var key = childElements[a].getAttribute('data-opbouw-key');
						var val = childElements[a].value;
						period[key] = val;
					}
					opbouwSchema['periode_' + (i + 1)] = period;
				}
				document.getElementById('opbouwSchema').value = JSON.stringify(opbouwSchema);
			}, 250);
		},

		/**
		 * Adds a new opbouw schema item to the 'opbouwSchemaContainer'.
		 * Initializes necessary elements and event listeners for the added item.
		 *
		 * @returns {void}
		 */
		add: function() {

			const clone = document.querySelector('.opbouw-schema-item').cloneNode(true);
			const container = document.getElementById('opbouwSchemaContainer');

			container.appendChild(clone);

			const buttonDelete = document.querySelector('.opbouw-schema-item:last-child .opbouw-schema-item-verwijder');
			buttonDelete.classList.remove('invisible');

			document.querySelector('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-datum').value = '';
			document.querySelector('.opbouw-schema-item:last-child .input-group .opbouw-schema-item-uren').value = '';

			datepicker.init(container);

		},

		/**
		 * Deletes the opbouw-schema item from the DOM based on the provided event.
		 *
		 * @param {Event} event - The event triggering the deletion.
		 *
		 * @returns {void}
		 */
		delete: function(event) {
			const el = event.target.closest('.opbouw-schema-item');
			el.parentNode.removeChild(el);
		},

	}

};

export default form;
